import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {RadioField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import ButtonField from 'app-ui-componentlibrary/dist/go/components/common/form/ButtonField';
import ContactInfoModal from 'go/components/modules/application/ContactInfoModal';
import SpanText from 'app-ui-componentlibrary/dist/go/components/common/form/SpanText';
import {ConfigNameValue as NameValue} from 'componentLibrary';
import {Header, Form, Grid, Card, Button, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {
  hasGrantWriterFee,
  getFirstErrorForField,
  displayObjectErrors,
  getFirstObjectError,
  parseError,
  generateTimeId,
} from 'common/utils';
import {produce} from 'immer';
import {
  ALWAYS_DIRTY_MAP,
  MAILING_ADDRESS,
} from 'app-ui-componentlibrary/dist/common/constants';
import {Toggle} from 'componentLibrary';
import {hasIdWithValue, produceAppliedDiff} from 'framework/collaboration/diff.utils';
export const PARTICIPANTS = 'participants';
export const POINT_OF_CONTACTS = 'pointOfContacts';
export const AORS = 'aors';

export const TYPE_MAPPING = {
  [PARTICIPANTS]: 'participants',
  [POINT_OF_CONTACTS]: 'point of contact',
  [AORS]: 'AOR',
};

export const ContactsList = (props) => {
  const {
    dataPath,
    contacts,
    handleEdit,
    handleDelete,
    showAdditionalPhones,
    showFax,
    showMailingAddress,
    deleteButtonMinSize,
    deleteFirstContact,
    isTitleRequired,
    validationErrors,
    readOnly,
    disableEdit,
    currentlyCollaborating,
  } = props;

  const canDeleteContact = (size, idx) => {
    if (size <= deleteButtonMinSize) return false;
    if (idx == 0 && !deleteFirstContact) return false;
    return true;
  };
  const getError = (fieldPath) => {
    return displayObjectErrors(validationErrors, ALWAYS_DIRTY_MAP, fieldPath);
  };

  const gridRows = [];
  _.map(contacts, (contact, idx) => {
    let mailing = _.get(contact, MAILING_ADDRESS, {});

    gridRows[idx] = (
      <Grid.Row columns={3} padded={false}>
        <Grid.Column className="overFlowText" width={4}>
          <Grid width={16} columns={1} padded={false} stackable centered>
            <Grid.Row columns={1} padded={false}>
              <Grid.Column width={16} padded={false}>
                <Card.Header>
                  <b>
                    {contact.prefix ? contact.prefix + ' ' : ''}
                    <SpanText
                      name={`${dataPath}[${idx}].firstName`}
                      value={contact.firstName}
                      displayError={getError([idx, 'firstName']).displayError}
                      errorMessages={getError([idx, 'firstName']).errorMessages}
                    />
                    {contact.middleInitial ? ' ' + contact.middleInitial : ''}
                    <SpanText
                      name={`${dataPath}[${idx}].lastName`}
                      value={contact.lastName ? ' ' + contact.lastName : ''}
                      displayError={getError([idx, 'lastName']).displayError}
                      errorMessages={getError([idx, 'lastName']).errorMessages}
                    />
                    {contact.suffix ? ' ' + contact.suffix : ''}
                  </b>
                </Card.Header>
                <Card.Content>
                  {isTitleRequired ? (
                    <SpanText
                      name={`${dataPath}[${idx}].title`}
                      value={contact.title}
                      displayError={getError([idx, 'title']).displayError}
                      errorMessages={getError([idx, 'title']).errorMessages}
                    />
                  ) : (
                    ''
                  )}
                </Card.Content>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1} padded={false}>
              <Grid.Column width={16} padded={false}>
                <Card.Content>&nbsp;</Card.Content>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1} padded={false}>
              <Grid.Column width={16} padded={false}>
                <Card.Content>
                  <SpanText
                    name={`${dataPath}.[${idx}].email`}
                    value={contact.email}
                    isHyperlink={!getError([idx, 'email']).displayError}
                    hyperlinkUrl={`mailto:${contact.email}`}
                    displayError={getError([idx, 'email']).displayError}
                    errorMessages={getError([idx, 'email']).errorMessages}
                  />
                </Card.Content>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
        <Grid.Column width={10}>
          <Grid width={16} columns={3} padded={false} stackable centered>
            <Grid.Row columns={2} padded={false}>
              <Grid.Column width={showMailingAddress ? 5 : 8} padded={false}>
                <Card.Header>
                  <b>Primary phone</b>
                </Card.Header>
                <Card.Content>
                  <SpanText
                    name={`${dataPath}[${idx}].phoneNumber`}
                    value={contact.phoneNumber}
                    displayError={getError([idx, 'phoneNumber']).displayError}
                    errorMessages={getError([idx, 'phoneNumber']).errorMessages}
                  />
                  {contact.extension ? ' ext ' + contact.extension : ''}
                </Card.Content>
                <Card.Content>
                  <SpanText
                    name={`${dataPath}[${idx}].phoneNumberType`}
                    value={_.upperFirst(contact.phoneNumberType)}
                    displayError={getError([idx, 'phoneNumberType']).displayError}
                    errorMessages={getError([idx, 'phoneNumberType']).errorMessages}
                  />
                </Card.Content>
              </Grid.Column>
              <Grid.Column width={showMailingAddress ? 5 : 8} padded={false}>
                {showAdditionalPhones ? (
                  <div>
                    <Card.Header>
                      <b>Additional phones</b>
                    </Card.Header>
                    <Card.Content>
                      <SpanText
                        name={`${dataPath}[${idx}].secondaryPhoneNumber`}
                        value={_.get(contact, 'secondaryPhoneNumber')}
                        displayError={
                          getError([idx, 'secondaryPhoneNumber']).displayError
                        }
                        errorMessages={
                          getError([idx, 'secondaryPhoneNumber']).errorMessages
                        }
                      />
                      {contact.secondaryPhoneExt
                        ? ' ext ' + contact.secondaryPhoneExt
                        : ''}
                    </Card.Content>
                    <Card.Content>
                      <SpanText
                        name={`${dataPath}[${idx}].secondaryPhoneType`}
                        value={_.upperFirst(contact.secondaryPhoneType)}
                        displayError={getError([idx, 'secondaryPhoneType']).displayError}
                        errorMessages={
                          getError([idx, 'secondaryPhoneType']).errorMessages
                        }
                      />
                    </Card.Content>
                  </div>
                ) : (
                  <Card.Content>&nbsp;</Card.Content>
                )}
              </Grid.Column>
              {showMailingAddress ? (
                <Grid.Column width={6} padded={false}>
                  <Card.Header>
                    <b>Mailing address</b>
                  </Card.Header>
                  <Card.Content className="overFlowText">
                    <SpanText
                      name={`${dataPath}[${idx}].mailingAddress.address1`}
                      value={mailing ? mailing.address1 : ''}
                      displayError={
                        getError([idx, MAILING_ADDRESS, 'address1']).displayError
                      }
                      errorMessages={
                        getError([idx, MAILING_ADDRESS, 'address1']).errorMessages
                      }
                    />
                  </Card.Content>
                  <Card.Content className="overFlowText">
                    <SpanText
                      name={`${dataPath}[${idx}].mailingAddress.address2`}
                      value={mailing ? mailing.address2 : ''}
                      displayError={
                        getError([idx, MAILING_ADDRESS, 'address2']).displayError
                      }
                      errorMessages={
                        getError([idx, MAILING_ADDRESS, 'address2']).errorMessages
                      }
                    />
                  </Card.Content>
                  <Card.Content className="overFlowText">
                    <SpanText
                      name={`${dataPath}[${idx}].mailingAddress.city`}
                      value={mailing ? mailing.city : ''}
                      displayError={getError([idx, MAILING_ADDRESS, 'city']).displayError}
                      errorMessages={
                        getError([idx, MAILING_ADDRESS, 'city']).errorMessages
                      }
                    />
                    &nbsp;
                    <SpanText
                      name={`${dataPath}[${idx}].mailingAddress.state`}
                      value={mailing ? mailing.state : ''}
                      displayError={
                        getError([idx, MAILING_ADDRESS, 'state']).displayError
                      }
                      errorMessages={
                        getError([idx, MAILING_ADDRESS, 'state']).errorMessages
                      }
                    />
                    &nbsp;
                    <SpanText
                      name={`${dataPath}[${idx}].mailingAddress.zip`}
                      value={mailing ? mailing.zip : ''}
                      displayError={getError([idx, MAILING_ADDRESS, 'zip']).displayError}
                      errorMessages={
                        getError([idx, MAILING_ADDRESS, 'zip']).errorMessages
                      }
                    />
                    <SpanText
                      name={`${dataPath}[${idx}].mailingAddress.zipExt`}
                      value={mailing.zipExt ? '-' + mailing.zipExt || '' : ''}
                      displayError={
                        getError([idx, MAILING_ADDRESS, 'zipExt']).displayError
                      }
                      errorMessages={
                        getError([idx, MAILING_ADDRESS, 'zipExt']).errorMessages
                      }
                    />
                  </Card.Content>
                </Grid.Column>
              ) : (
                ''
              )}
            </Grid.Row>
            <Grid.Row columns={2} padded={false}>
              {showFax ? (
                <Grid.Column width={showMailingAddress ? 5 : 8}>
                  <Card.Header>
                    <b>Fax</b>
                  </Card.Header>
                  <Card.Content>
                    <SpanText
                      name={`${dataPath}[${idx}].fax`}
                      value={contact.fax}
                      displayError={getError([idx, 'fax']).displayError}
                      errorMessages={getError([idx, 'fax']).errorMessages}
                    />
                  </Card.Content>
                </Grid.Column>
              ) : (
                ''
              )}
              <Grid.Column width={showMailingAddress ? 5 : 8}>
                <Card.Header>&nbsp;</Card.Header>
                {showAdditionalPhones && contact.optionalPhoneNumber ? (
                  <Card.Content>
                    {contact.optionalPhoneNumber}
                    {contact.optionalPhoneExt ? ' ext ' + contact.optionalPhoneExt : ''}
                  </Card.Content>
                ) : (
                  ''
                )}
                {showAdditionalPhones && contact.optionalPhoneNumber ? (
                  <Card.Content>{_.upperFirst(contact.optionalPhoneType)}</Card.Content>
                ) : (
                  ''
                )}
              </Grid.Column>
              {showMailingAddress ? <Grid.Column width={6} /> : ''}
            </Grid.Row>
          </Grid>
        </Grid.Column>
        {!readOnly && (
          <Grid.Column width={2}>
            <Grid width={16} columns={3} padded={false} stackable centered>
              <Grid.Row columns={1} padded={false}>
                {!disableEdit ? (
                  <Grid.Column width={16} padded={false}>
                    <Button
                      id={
                        currentlyCollaborating ? `edit-btn-${contact.id}` : contact.email
                      }
                      className="mini button"
                      labelPosition="left"
                      onClick={() => handleEdit(idx, contact.id)}
                    >
                      <Icon
                        className="fitted link"
                        id={
                          currentlyCollaborating
                            ? `edit-icn-${contact.id}`
                            : contact.email
                        }
                        name="pencil"
                        size="small"
                        color="blue"
                      />
                      <font className="ui.blue.button.smallLabel">Edit</font>
                    </Button>
                  </Grid.Column>
                ) : (
                  <Grid.Column width={16} padded={false}>
                    &nbsp;
                  </Grid.Column>
                )}
                <Grid.Column width={16} padded={false}>
                  &nbsp;
                </Grid.Column>
                {canDeleteContact(_.size(contacts), idx) ? (
                  <Grid.Column width={16}>
                    <Button
                      id={
                        currentlyCollaborating
                          ? `delete-btn-${contact.id}`
                          : contact.email
                      }
                      className="mini button"
                      labelPosition="left"
                      onClick={() => handleDelete(idx, contact.id)}
                    >
                      <Icon
                        className="fitted link"
                        id={
                          currentlyCollaborating
                            ? `delete-icn-${contact.id}`
                            : contact.email
                        }
                        name="pencil"
                        size="small"
                        color="blue"
                      />
                      <font className="ui.blue.button.smallLabel">Delete</font>
                    </Button>
                  </Grid.Column>
                ) : (
                  <Grid.Column width={16} padded={false}>
                    &nbsp;
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>
          </Grid.Column>
        )}
      </Grid.Row>
    );
  });
  return gridRows;
};

export class ContactInformation extends React.Component {
  state = {
    contactInfoModalIsOpen: false,
    contactInfoModalType: '',
    contactInfoIndex: 0,
    contactInfoId: '',
    contactInfoConfig: {},
    contactInfo: {},
  };

  dataWithIds(pr) {
    return produce(pr, (draft) => {
      let types = Object.keys(TYPE_MAPPING);
      for (const type of types) {
        if (_.get(draft, type)) {
          _.set(
            draft,
            type,
            _.map(draft[type], (c, idx) => {
              c.id = c.id || `${idx}-${generateTimeId()}`;
              return c;
            })
          );
        }
      }
    });
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.data)) {
      if (this.props.currentlyCollaborating) {
        this.setState({contactInfo: this.dataWithIds(this.props.data)});
        return;
      }
      this.setState({contactInfo: this.props.data});
    }
  }

  componentWillUnmount() {
    //empty
  }

  componentDidUpdate(prevProps) {
    if (this.props.data && !_.isEqual(prevProps.data, this.props.data)) {
      if (this.props.currentlyCollaborating) {
        let prevPropsData = this.dataWithIds(prevProps.data);
        let thisPropsData = this.dataWithIds(this.props.data);

        this.setState((prevState) => {
          const updatedContactInfo = produceAppliedDiff(
            prevPropsData,
            thisPropsData,
            prevState?.contactInfo
          );
          //if currently editing contact is deleted remotely then also close modal
          if (
            prevState?.contactInfoModalIsOpen &&
            prevState?.contactInfoId &&
            !hasIdWithValue(updatedContactInfo, prevState?.contactInfoId)
          ) {
            return {
              contactInfo: updatedContactInfo,
              contactInfoModalIsOpen: false,
            };
          } else {
            return {
              contactInfo: updatedContactInfo,
            };
          }
        });
        return;
      }
      this.setState({contactInfo: this.props.data});
    }
  }

  saveContactInfo = (fieldName) => {
    const {saveEntityData, validationId, entityType, entityDataPath} = this.props;
    saveEntityData(
      entityDataPath,
      entityType,
      this.state.contactInfo,
      validationId + '.' + fieldName
    );
  };

  getContactConfig = (type) => {};

  createUser = (type) => {
    const {
      saveEntityData,
      entityDataPath,
      entityType,
      validationId,
      currentlyCollaborating,
    } = this.props;
    const {contactInfo} = this.state;
    const numOfContacts = _.size(_.get(contactInfo, type));
    const newId = generateTimeId();
    const config = _.get(this.props, type);

    this.setState({
      contactInfoModalIsOpen: true,
      contactInfoModalType: type,
      contactInfoIndex: numOfContacts,
      contactInfoId: newId,
      contactInfoConfig: config,
    });
    if (type !== 'aors') {
      this.setState(
        {
          contactInfo: produce(contactInfo, (draft) => {
            if (currentlyCollaborating) {
              draft[type] = draft[type] || [];
              draft[type].push({
                id: newId,
                type: 'alternate',
              });
              return;
            }
            _.set(draft, [type, numOfContacts], {
              type: 'alternate',
            });
          }),
        },
        () => {
          saveEntityData(
            entityDataPath,
            entityType,
            this.state.contactInfo,
            validationId
          );
        }
      );
    } else if (currentlyCollaborating) {
      this.setState(
        {
          contactInfo: produce(contactInfo, (draft) => {
            draft[type] = draft[type] || [];
            draft[type].push({
              id: newId,
            });
            return;
          }),
        },
        () => {
          saveEntityData(
            entityDataPath,
            entityType,
            this.state.contactInfo,
            validationId
          );
        }
      );
    }
  };

  handleEdit = (type, index, id) => {
    const config = _.get(this.props, type);
    this.setState({
      contactInfoModalIsOpen: true,
      contactInfoModalType: type,
      contactInfoConfig: config,
      contactInfoIndex: index,
      contactInfoId: id,
    });
  };

  handleDelete = (type, index, id) => {
    const {saveEntityData, validationId, entityDataPath, entityType} = this.props;
    const {contactInfo} = this.state;

    this.setState(
      {
        contactInfo: produce(contactInfo, (draft) => {
          if (this.props.currentlyCollaborating) {
            _.set(
              draft,
              type,
              _.filter(_.get(draft, type, []), (c) => c.id !== id)
            );
            return;
          }
          _.get(draft, type, []).splice(index, 1);
        }),
      },
      () =>
        saveEntityData(entityDataPath, entityType, this.state.contactInfo, validationId)
    );
  };

  handleContactChange = (contactType, contactIndex, name, value, contactId) => {
    this.setState({
      contactInfo: produce(this.state.contactInfo, (draft) => {
        if (this.props.currentlyCollaborating) {
          let contact = _.find(_.get(draft, contactType, []), (c) => c.id === contactId);
          if (!contact) {
            // contact was deleted while we were editing.. restore somehow???
            _.set(draft, `${contactType}.${_.size(_.get(draft, contactType))}`, {
              [name]: value,
              id: contactId,
            });
          } else {
            _.set(contact, name, value);
          }
          return;
        }
        _.set(draft, `${contactType}.${contactIndex}.${name}`, value);
      }),
    });
  };

  handleContactChoose = (contactType, contactIndex, updateContact, id) => {
    if (contactType === AORS && _.isEmpty(updateContact.email)) return;
    this.setState(
      {
        contactInfo: produce(this.state.contactInfo, (draft) => {
          if (this.props.currentlyCollaborating) {
            const newContact = {
              ...updateContact,
              id,
            };
            let idx = _.findIndex(_.get(draft, contactType), (c) => c.id === id);
            if (idx === -1) {
              // contact was deleted while we were editing... restore somehow?
              _.set(draft, contactType, [..._.get(draft, contactType, []), newContact]);
            } else {
              draft[contactType][idx] = newContact;
            }
            return;
          }
          _.set(draft, `${contactType}.${contactIndex}`, updateContact);
        }),
      },
      () => this.handleBlur()
    );
  };

  handleBlur = (fieldPath) => {
    const {saveEntityData, entityType, entityDataPath, validationId} = this.props;
    const {contactInfo} = this.state;
    saveEntityData(
      entityDataPath,
      entityType,
      contactInfo,
      `${validationId}.${fieldPath}`
    );
  };

  handleRadioChange = (e, data) => {
    const {contactInfo} = this.state;

    if (data) {
      if ('Y' === data.value) {
        this.setState(
          {
            contactInfo: produce(contactInfo, (draft) => {
              draft.hasPreparer = true;
            }),
          },
          () => this.saveContactInfo('hasPreparer')
        );
      } else if ('N' === data.value) {
        this.setState(
          {
            contactInfo: produce(contactInfo, (draft) => {
              draft.hasPreparer = false;
              draft.participants = undefined;
            }),
          },
          () => this.saveContactInfo('hasPreparer')
        );
      }
    }
  };

  getErrorsForType = (type) => {
    const {validationErrors} = this.props;
    return _.get(getFirstErrorForField(validationErrors, type), 'error');
  };

  render() {
    const {token} = this.props;
    const {
      entityDataPath,
      validationDirtyMap,
      validationErrors,
      organizationId,
      parentOrgId,
      fundingStreams,
      readOnly,
      pocAllowed,
      participantsAllowed,
      pointOfContacts,
      participants,
      aors,
      sars,
      fullValidationDirtyMap,
      currentlyCollaborating,
    } = this.props;

    const userAORorSAR = _.get(this.props, 'toggles', []).includes('manageTeamOrgSubOrg');

    let AORS = userAORorSAR ? 'sars' : 'aors';
    const maxPointOfContacts = pocAllowed
      ? pocAllowed //backward compatibility
      : pointOfContacts && pointOfContacts.max
      ? pointOfContacts.max
      : -1;

    const maxParticipants = participantsAllowed
      ? participantsAllowed
      : participants && participants.max
      ? participants.max
      : -1;

    const maxAors = userAORorSAR
      ? sars && sars.max
        ? sars.max
        : -1
      : aors && aors.max
      ? aors.max
      : -1;
    const disablePointOfContacts = pointOfContacts && pointOfContacts.hidden;
    const disableParticipants = participants && participants.hidden;
    const disableAors = userAORorSAR ? !sars || sars.hidden : !aors || aors.hidden;

    const hasPreparerRadioField = {
      guidance:
        'Did any individual or organization assist with the development, preparation, or review of the application to include drafting or writing the narrative and budget, whether that person, entity, or agent is compensated or not and whether the assistance took place prior to submitting the application?',
      options: [
        {label: 'Yes', disabled: false, value: 'Y'},
        {label: 'No', disabled: false, value: 'N'},
      ],
      pathToBeUsed: entityDataPath + '.hasPreparer',
      formOptions: '',
    };

    const addAorButton = !disableAors && {
      submitButtonLabel: userAORorSAR ? 'Add a SAR' : 'Add an AOR',
      name: 'addAORButton',
      id: 'addAORButton',
      color: 'blue',
      handleClick: () => this.createUser(AORS),
    };

    const addParticipantButton = !disableParticipants && {
      submitButtonLabel: 'Add a participant',
      name: 'addParticipantButton',
      id: 'addParticipantButton',
      color: 'blue',
      handleClick: () => this.createUser(PARTICIPANTS),
    };

    const addPointOfContactButton = !disablePointOfContacts && {
      submitButtonLabel: 'Add a point of contact',
      name: 'addPointOfContactButton',
      id: 'addPointOfContactButton',
      color: 'blue',
      handleClick: () => this.createUser(POINT_OF_CONTACTS),
    };

    let {contactInfo, contactInfoModalType, contactInfoIndex, contactInfoId} = this.state;

    if (currentlyCollaborating) {
      contactInfoIndex = _.findIndex(
        _.get(contactInfo, contactInfoModalType),
        (c) => c.id === contactInfoId
      );
    }

    let matchingParticipant = _.get(contactInfo, [
      contactInfoModalType,
      contactInfoIndex,
    ]);

    const participantErrors = this.getErrorsForType(PARTICIPANTS);
    const pointOfContactErrors = this.getErrorsForType(POINT_OF_CONTACTS);
    const aorErrors = this.getErrorsForType(AORS);

    const firstErrors = [
      {
        header: _.upperFirst(TYPE_MAPPING[PARTICIPANTS]),
        itemErrors: parseError(participantErrors),
      },
      {
        header: _.upperFirst(TYPE_MAPPING[POINT_OF_CONTACTS]),
        itemErrors: parseError(pointOfContactErrors),
      },
      {
        header: _.upperFirst(TYPE_MAPPING[AORS]),
        itemErrors: parseError(aorErrors),
      },
    ];

    const firstError = _.find(firstErrors, (err) => err.itemErrors !== undefined);

    const duplicatePointOfContactErrors = getFirstErrorForField(
      validationErrors,
      'duplicatePointsOfContactEmail'
    );

    const selectedContactErrors = _.get(
      this.getErrorsForType(contactInfoModalType),
      contactInfoIndex
    );

    const selectedContactDirtyMap = {
      ..._.get(
        validationDirtyMap,
        `dirty.${contactInfoModalType}[${contactInfoIndex}]`,
        {}
      ),
      dirtyPage: _.get(validationDirtyMap, 'dirtyPage', false),
    };

    const hasPreparerDisplayError =
      _.get(getFirstErrorForField(validationErrors, 'hasPreparer'), 'isValid') ===
        false &&
      (_.get(validationDirtyMap, 'dirtyPage') ||
        _.get(validationDirtyMap, 'hasPreparer', false) ||
        _.get(fullValidationDirtyMap, 'contactInformation.hasPreparer', false));
    const hasPreparerErrorMessages = _.get(
      getFirstErrorForField(validationErrors, 'hasPreparer'),
      'message'
    );

    return (
      <Form>
        <Grid
          key={'contactInformationGrid'}
          stackable
          reversed="mobile"
          padded="vertically"
        >
          <Grid.Column mobile={16} tablet={16} computer={16}>
            {!disableParticipants && (
              <React.Fragment>
                {readOnly ? (
                  <div className="margin-bottom--standard">
                    <NameValue
                      name={hasPreparerRadioField.label || hasPreparerRadioField.guidance}
                      data={
                        contactInfo.hasPreparer === undefined
                          ? ''
                          : contactInfo.hasPreparer
                          ? 'Yes'
                          : 'No'
                      }
                    />
                  </div>
                ) : (
                  <React.Fragment>
                    <RadioField
                      value={_.get(contactInfo, 'hasPreparer')}
                      guidance={hasPreparerRadioField.guidance}
                      options={hasPreparerRadioField.options}
                      name={hasPreparerRadioField.pathToBeUsed}
                      displayError={hasPreparerDisplayError}
                      errorMessages={hasPreparerErrorMessages}
                      handleChange={this.handleRadioChange}
                      handleBlur={() => this.handleBlur(`hasPreparer`)}
                    />
                    {hasGrantWriterFee(fundingStreams) && (
                      <Alert
                        size="medium"
                        header="Grant writer fee"
                        content=" In order to request a grant writer fee, the answer to this question must be “Yes”"
                        type="info"
                        dismissable={false}
                      />
                    )}
                  </React.Fragment>
                )}

                {!contactInfo.hasPreparer && hasGrantWriterFee(fundingStreams) && (
                  <Alert
                    size="medium"
                    header=""
                    content="You must add individuals or organizations who assisted you with the application."
                    type="error"
                    dismissable={false}
                  />
                )}

                {contactInfo.hasPreparer && (
                  <div className="padding-bottom--double">
                    <Header
                      as="h4"
                      content="Application participants"
                      id="applicationParticipantsHeader"
                    />
                    <hr />
                    <div className="textMedium">
                      Please add all individuals or organizations who assisted with the
                      application.
                    </div>
                    <br />
                    <div>
                      Include all individuals or organizations who assisted with the
                      development, preparation, or review of the application to include
                      drafting or writing the narrative and budget, whether that person,
                      entity, or agent is compensated or not and whether the assistance
                      took place prior to submitting the application or not.
                    </div>
                    <br />
                    {!contactInfo.participants ||
                    contactInfo.participants.length === 0 ? (
                      <Alert type="error" header="Add a participant." paragraph={false}>
                        At least one participant is required.
                      </Alert>
                    ) : (
                      <div>
                        {!_.isEmpty(firstError) && (
                          <Alert
                            type="error"
                            header={`${firstError.header} error`}
                            paragraph={false}
                          >
                            {_.get(getFirstObjectError(firstError.itemErrors), 'message')}
                          </Alert>
                        )}
                        <Grid width={16} columns={3} divided="vertically" celled>
                          <ContactsList
                            dataPath={`${entityDataPath}.${PARTICIPANTS}`}
                            contacts={contactInfo.participants}
                            handleEdit={(index, id) =>
                              this.handleEdit(PARTICIPANTS, index, id)
                            }
                            handleDelete={(index, id) =>
                              this.handleDelete(PARTICIPANTS, index, id)
                            }
                            showAdditionalPhones={false}
                            showMailingAddress={true}
                            showFax={true}
                            deleteButtonMinSize={1}
                            deleteFirstContact={true}
                            isTitleRequired={false}
                            validationErrors={participantErrors}
                            readOnly={readOnly}
                            currentlyCollaborating={currentlyCollaborating}
                          />
                        </Grid>
                      </div>
                    )}
                    {!readOnly &&
                      (maxParticipants < 0 ||
                        _.size(_.get(contactInfo, 'participants')) < maxParticipants) && (
                        <ButtonField
                          buttonText={addParticipantButton.submitButtonLabel}
                          name={addParticipantButton.name}
                          id={addParticipantButton.id}
                          handleClick={addParticipantButton.handleClick}
                          color={addParticipantButton.color}
                        />
                      )}
                  </div>
                )}
              </React.Fragment>
            )}

            {!disableAors && (
              <React.Fragment>
                <br />
                <div>
                  <Header
                    as="h4"
                    content={_.get(
                      userAORorSAR ? this.props.sars : this.props.aors,
                      'header',
                      userAORorSAR
                        ? 'Subrecipient Authorized Representative (SAR)'
                        : 'Authorized Organisation Representatives (AOR)'
                    )}
                    id="aorHeader"
                  />
                  <hr />
                  {_.get(this.props.sars, 'instructions.main') && (
                    <div className="textMedium">{this.props.sars.instructions.main}</div>
                  )}
                  {_.get(this.props.sars, 'instructions.additional') && (
                    <React.Fragment>
                      <br />
                      <div>{this.props.sars.instructions.additional}</div>
                    </React.Fragment>
                  )}
                  <br />

                  {userAORorSAR ? (
                    !contactInfo.sars || contactInfo.sars.length === 0 ? (
                      <Alert
                        type="error"
                        header="Add Subrecipient Authorized Representative."
                        paragraph={false}
                      >
                        At least one subrecipient authorized representative is required.
                      </Alert>
                    ) : (
                      <Grid width={16} columns={3} divided="vertically" celled>
                        <ContactsList
                          dataPath={`${entityDataPath}.${AORS}`}
                          contacts={contactInfo.sars}
                          handleDelete={(index, id) => this.handleDelete(AORS, index, id)}
                          deleteButtonMinSize={0}
                          deleteFirstContact={true}
                          showAdditionalPhones={false}
                          showFax={false}
                          showMailingAddress={true}
                          isTitleRequired={true}
                          validationErrors={aorErrors}
                          readOnly={readOnly}
                          disableEdit={true}
                          currentlyCollaborating={currentlyCollaborating}
                        />
                      </Grid>
                    )
                  ) : !contactInfo.aors || contactInfo.aors.length === 0 ? (
                    <Alert
                      type="error"
                      header="Add an authorized organization representative."
                      paragraph={false}
                    >
                      At least one authorized organization representative is required.
                    </Alert>
                  ) : (
                    <Grid width={16} columns={3} divided="vertically" celled>
                      <ContactsList
                        dataPath={`${entityDataPath}.${AORS}`}
                        contacts={contactInfo.aors}
                        handleDelete={(index, id) => this.handleDelete(AORS, index, id)}
                        deleteButtonMinSize={0}
                        deleteFirstContact={true}
                        showAdditionalPhones={false}
                        showFax={false}
                        showMailingAddress={true}
                        isTitleRequired={true}
                        validationErrors={aorErrors}
                        readOnly={readOnly}
                        disableEdit={true}
                        currentlyCollaborating={currentlyCollaborating}
                      />
                    </Grid>
                  )}
                  {!readOnly &&
                    (maxAors < 0 || _.size(_.get(contactInfo, 'aors')) < maxAors) && (
                      <ButtonField
                        buttonText={addAorButton.submitButtonLabel}
                        name={addAorButton.name}
                        id={addAorButton.id}
                        handleClick={addAorButton.handleClick}
                        color={addAorButton.color}
                      />
                    )}
                </div>
              </React.Fragment>
            )}

            {!disablePointOfContacts && (
              <React.Fragment>
                <br />
                <div>
                  <Header
                    as="h4"
                    content={_.get(
                      this.props,
                      'pointOfContacts.header',
                      'Secondary point of contact'
                    )}
                    id="secondaryContactHeader"
                  />
                  <hr />
                  <div className="textMedium">
                    {_.get(
                      this.props,
                      'pointOfContacts.instructions.main',
                      'Please provide a secondary point of contact for this grant.'
                    )}
                  </div>
                  {this.props.pointOfContacts ? (
                    this.props.pointOfContacts.instructions.additional && (
                      <React.Fragment>
                        <br />
                        <div>{this.props.pointOfContacts.instructions.additional}</div>
                      </React.Fragment>
                    )
                  ) : (
                    <React.Fragment>
                      <br />
                      <div>
                        The Authorized Organization Representative (AOR) who submits the
                        application will be identified as the primary point of contact for
                        the grant. Please provide one secondary point of contact for this
                        grant below. The secondary contact can be members of the fire
                        department or organizations applying for the grant that will see
                        the grant through completion, are familiar with the grant
                        application, and have the authority to make decisions on and to
                        act upon this grant application. The secondary point of contact
                        can also be an individual who assisted with the development,
                        preparation, or review of the application.
                      </div>
                    </React.Fragment>
                  )}

                  <br />

                  {!contactInfo.pointOfContacts ||
                  contactInfo.pointOfContacts.length === 0 ? (
                    <Alert
                      type="error"
                      header="Add a point of contact."
                      paragraph={false}
                    >
                      At least one point of contact is required.
                    </Alert>
                  ) : (
                    <React.Fragment>
                      <Grid width={16} columns={3} divided="vertically" celled>
                        <ContactsList
                          dataPath={`${entityDataPath}.${POINT_OF_CONTACTS}`}
                          contacts={contactInfo.pointOfContacts}
                          handleEdit={(index, id) =>
                            this.handleEdit(POINT_OF_CONTACTS, index, id)
                          }
                          handleDelete={(index, id) =>
                            this.handleDelete(POINT_OF_CONTACTS, index, id)
                          }
                          showAdditionalPhones={true}
                          showFax={true}
                          showMailingAddress={
                            pointOfContacts
                              ? _.get(pointOfContacts, 'showMailingAddress')
                              : false
                          }
                          deleteButtonMinSize={1}
                          deleteFirstContact={
                            pointOfContacts
                              ? _.get(pointOfContacts, 'deleteFirstContact')
                              : true
                          }
                          isTitleRequired={true}
                          validationErrors={pointOfContactErrors}
                          readOnly={readOnly}
                          currentlyCollaborating={currentlyCollaborating}
                        />
                      </Grid>
                    </React.Fragment>
                  )}

                  {!readOnly &&
                    (maxPointOfContacts < 0 ||
                      _.size(_.get(contactInfo, 'pointOfContacts')) <
                        maxPointOfContacts) && (
                      <ButtonField
                        buttonText={addPointOfContactButton.submitButtonLabel}
                        name={addPointOfContactButton.name}
                        id={addPointOfContactButton.id}
                        handleClick={addPointOfContactButton.handleClick}
                        color={addPointOfContactButton.color}
                      />
                    )}
                </div>
              </React.Fragment>
            )}

            <ContactInfoModal
              config={this.state.contactInfoConfig}
              contact={matchingParticipant}
              handleChange={(name, value) =>
                this.handleContactChange(
                  this.state.contactInfoModalType,
                  this.state.contactInfoIndex,
                  name,
                  value,
                  this.state.contactInfoId
                )
              }
              handleDelete={() => {
                this.handleDelete(
                  this.state.contactInfoModalType,
                  this.state.contactInfoIndex,
                  this.state.contactInfoId
                );
                this.setState({contactInfoModalIsOpen: false});
              }}
              handleChoose={(newContact) =>
                this.handleContactChoose(
                  this.state.contactInfoModalType,
                  this.state.contactInfoIndex,
                  newContact,
                  this.state.contactInfoId
                )
              }
              handleBlur={(fieldPath) =>
                currentlyCollaborating
                  ? this.handleBlur(
                      `${contactInfoModalType}[${_.findIndex(
                        _.get(contactInfo, contactInfoModalType),
                        (c) => c.id === this.state.contactInfoId
                      )}].${fieldPath}`
                    )
                  : this.handleBlur(
                      `${contactInfoModalType}[${contactInfoIndex}].${fieldPath}`
                    )
              }
              token={token}
              open={this.state.contactInfoModalIsOpen}
              type={this.state.contactInfoModalType}
              handleClose={() => {
                if (
                  !duplicatePointOfContactErrors ||
                  duplicatePointOfContactErrors.isValid === true
                ) {
                  this.setState({contactInfoModalIsOpen: false});
                }
              }}
              validationErrors={selectedContactErrors}
              validationDirtyMap={selectedContactDirtyMap}
              organizationId={organizationId}
              parentOrgId={parentOrgId}
              duplicatePointOfContactErrors={duplicatePointOfContactErrors}
            />
          </Grid.Column>
        </Grid>
      </Form>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
    fullValidationDirtyMap: _.get(state, 'dynamicComponent.validationDirtyMap'),
    currentlyCollaborating: !!_.get(state, 'dynamicComponent.collaboration.roomList', ''),
  };
};
export default connect(mapStateToProps, null)(connectDynamic(ContactInformation));
